'use client';

import { Routes } from '@/lib/routes/routes';
import useCmsStore from '@/lib/state-stores/cmsStore';
import { DestinationValue } from '@/types/cms';
import { Link } from '@/i18n/routing';
import React, { FC, ReactNode } from 'react';

const ListOfBranchesDestination: FC<{
  destinationValue: DestinationValue;
  children: ReactNode;
}> = ({ children, destinationValue }) => {
  const { updateDestinationValue } = useCmsStore();
  return (
    <Link
      href={Routes.customListOfBranches}
      onClick={() => {
        updateDestinationValue(destinationValue);
      }}
    >
      <span className="sr-only">View product details</span>

      {children}
    </Link>
  );
};

export default ListOfBranchesDestination;
